/* import $ from 'jquery'

$(document).ready(dhsv_vc_downloads)

function dhsv_vc_downloads() {
  $('.dhsv_vc_downloads').each(function() {
    const $this = $(this)
    $this.find('btn').on('click tap', function() {
      //
    })
  })
} */
